import { USERS } from "../Constants/Endpoinst";
import { ApiRequestInterceptor } from "./apiRequest";

/**
 * Hace GET a /users/{username}/{date}
 * `date` puede ser "YYYY-MM-DD" o un startTime en milisegundos (p.ej. "1753980914103")
 * Espera que la respuesta sea:
 *   { items: [ ... ] }
 * Devuelve { items, lastKey: null } por compatibilidad.
 */
// Antes retornabas solo items; ahora también routeDays
export const fetchUserRoutes = async (username, _lastKey = null, filterDate = "") => {
  if (!filterDate) {
    throw new Error("Se requiere una fecha (YYYY-MM-DD) o startTime en milisegundos");
  }

  const method = "GET";
  const loginData = JSON.parse(localStorage.getItem("logindata") || "{}");
  const token = loginData?.data?.token;
  const headers = token ? { Authorization: `Bearer ${token}` } : {};

  const path = USERS.userRoutes
    .replace("{username}", encodeURIComponent(username))
    .replace("{date}", encodeURIComponent(filterDate));

  const response = await ApiRequestInterceptor(path, method, null, headers);

  if (response.code === 200) {
    return {
      items: response.data.items,
      routeDays: response.data.routeDays || [],
      lastKey: null,
    };
  }

  // Si viene 404 pero trae routeDays, lo aceptamos (no es fatal para el calendario)
  if (response.code === 404 && response.data?.routeDays) {
    return {
      items: [],
      routeDays: response.data.routeDays,
      lastKey: null,
    };
  }

  throw new Error("Error al obtener las rutas del usuario");
};


